var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasilEyeOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1265_7798)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91211 9.82855C8.91211 9.01414 9.23563 8.23309 9.81151 7.65721C10.3874 7.08134 11.1684 6.75781 11.9828 6.75781C12.7973 6.75781 13.5783 7.08134 14.1542 7.65721C14.7301 8.23309 15.0536 9.01414 15.0536 9.82855C15.0536 10.643 14.7301 11.424 14.1542 11.9999C13.5783 12.5758 12.7973 12.8993 11.9828 12.8993C11.1684 12.8993 10.3874 12.5758 9.81151 11.9999C9.23563 11.424 8.91211 10.643 8.91211 9.82855ZM11.9828 7.98611C11.4942 7.98611 11.0256 8.18022 10.68 8.52575C10.3345 8.87127 10.1404 9.33991 10.1404 9.82855C10.1404 10.3172 10.3345 10.7858 10.68 11.1314C11.0256 11.4769 11.4942 11.671 11.9828 11.671C12.4715 11.671 12.9401 11.4769 13.2857 11.1314C13.6312 10.7858 13.8253 10.3172 13.8253 9.82855C13.8253 9.33991 13.6312 8.87127 13.2857 8.52575C12.9401 8.18022 12.4715 7.98611 11.9828 7.98611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6975 8.73109C5.3544 9.22568 5.2283 9.61301 5.2283 9.83983C5.2283 10.0667 5.3544 10.454 5.6975 10.9486C6.02996 11.426 6.52292 11.9443 7.14689 12.4233C8.3973 13.3831 10.1112 14.1389 11.9839 14.1389C13.8567 14.1389 15.5705 13.3831 16.821 12.4233C17.4449 11.9443 17.9379 11.426 18.2703 10.9486C18.6134 10.454 18.7395 10.0667 18.7395 9.83983C18.7395 9.61301 18.6134 9.22568 18.2703 8.73109C17.9379 8.25369 17.4449 7.73535 16.821 7.25632C15.5705 6.29661 13.8567 5.5408 11.9839 5.5408C10.1112 5.5408 8.3973 6.29661 7.14689 7.25632C6.52292 7.73535 6.02996 8.25369 5.6975 8.73109ZM6.39845 6.28187C7.81591 5.19442 9.78609 4.3125 11.9839 4.3125C14.1818 4.3125 16.1519 5.19442 17.5686 6.28187C18.2785 6.82641 18.8648 7.43401 19.2792 8.03096C19.6821 8.61154 19.9678 9.24779 19.9678 9.83983C19.9678 10.4319 19.6812 11.0681 19.2792 11.6487C18.8648 12.2457 18.2785 12.8524 17.5694 13.3978C16.1528 14.4852 14.1818 15.3672 11.9839 15.3672C9.78609 15.3672 7.81591 14.4852 6.39927 13.3978C5.68932 12.8532 5.10301 12.2457 4.68866 11.6487C4.2866 11.0681 4 10.4319 4 9.83983C4 9.24779 4.2866 8.61154 4.68866 8.03096C5.10301 7.43401 5.68932 6.82723 6.39845 6.28187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1265_7798",
    x: -1.8418,
    y: 0,
    width: 27.6523,
    height: 27.6562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1265_7798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1265_7798",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasilEyeOutline);
export default __webpack_public_path__ + "static/media/basil_eye-outline.25692d65f9d286ddba3726b9f1f2464b.svg";
export { ForwardRef as ReactComponent };